import { MYMLSTATE } from '.'
import { MYML_LOCATIONS, MymlEvent } from '../constants/enums'
import { Recommendation } from '../mfcLogic/api/modelsYouMayLike'
import { pubSubMyml } from './pubSub'

export const setMymlResults = (
    id: number,
    results: Array<Recommendation>,
    location: MYML_LOCATIONS,
) => {
    MYMLSTATE[location] = {
        results,
        id,
        timestamp: +new Date(),
    }
    pubSubMyml.emit(MymlEvent.UPDATE_RESULTS, MYMLSTATE[location], false)
}
